import { useTellescopeCountQuery } from "@tellescope/tanstack-query";

export const InboxUnreadCountBadge = () => {
  const query = useTellescopeCountQuery({
    model: "inbox_threads",
    method: "load_threads",
    request: {
      autobuild: true,
      mdbFilter: {
        inboxStatus: "New",
      },
    },
    select: (data) => data.count,
  });

  if (!query.data) {
    return null;
  }

  return <p className="text-muted-foreground">{query.data}</p>;
};
